// @flow
import channelStats from './channelStatsReducer';
import channelContentQueue from './channelContentQueueReducer';

export default {
  channelStats,
  channelContentQueue,
};



// WEBPACK FOOTER //
// ./src/containers/channels/reducer.js